export default function (elements) {
    window.addEventListener("load", () => {
        console.log("event listened edit2");
        const callback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("animate");
                    console.log("intersected")
                }
            });
        };
    
        const observer = (threshold) => {
            return new IntersectionObserver(callback, {
                threshold: [threshold]
            });
        };
    
        elements.forEach((el) => {
            if (document.querySelector(el.selector)) {
                if (el.multiple) {
                    document.querySelectorAll(el.selector).forEach(multiple => {
                        observer(el.offset).observe(multiple);
                    })
                } else {
                    observer(el.offset).observe(document.querySelector(el.selector));
                }
            }
        });
    });
}